import { schema, t } from '@colyseus/schema'

/** A sim `Projectile` (spike ball, homing drone), same fields. Matched across patches by `id`. */
export const ProjectileSchema = schema(
  {
    id: t.number().default(0),
    /** `ProjectileKind`. */
    kind: t.string().default(''),
    owner: t.number().default(0),
    x: t.float64().default(0),
    y: t.float64().default(0),
    w: t.float64().default(0),
    h: t.float64().default(0),
    vx: t.float64().default(0),
    vy: t.float64().default(0),
    grounded: t.boolean().default(false),
    target: t.number().default(0),
    locked: t.boolean().default(false),
    expiresAtTick: t.number().default(0),
  },
  'ProjectileSchema',
)
export type ProjectileSchema = InstanceType<typeof ProjectileSchema>

/** A sim `Trap` (trip wire), same fields. */
export const TrapSchema = schema(
  {
    id: t.number().default(0),
    /** `TrapKind`. */
    kind: t.string().default(''),
    owner: t.number().default(0),
    x: t.float64().default(0),
    y: t.float64().default(0),
    w: t.float64().default(0),
    h: t.float64().default(0),
    vy: t.float64().default(0),
    grounded: t.boolean().default(false),
    ownerSafeUntil: t.number().default(0),
    expiresAtTick: t.number().default(0),
  },
  'TrapSchema',
)
export type TrapSchema = InstanceType<typeof TrapSchema>

/** A sim `PlatformState`: moving platform position and crumble ticks, by platform index. */
export const PlatformSchema = schema(
  {
    x: t.float64().default(0),
    y: t.float64().default(0),
    fallAt: t.number().default(0),
    backAt: t.number().default(0),
  },
  'PlatformSchema',
)
export type PlatformSchema = InstanceType<typeof PlatformSchema>
